import * as Yup from 'yup';

export const newBusinessSchema = Yup.object().shape({
    businessName: Yup.string('BusinessName must be in String').max(50).required('Please Enter Your Business Name'),
    businessWebsite: Yup.string()
        .matches(/((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/, 'Enter correct url!')
        .max(200)
        .required('Please Enter Your Business Website URL'),
    name: Yup.string('Name must be in String').max(40).required('Please Enter Your Name'),
    email: Yup.string().email("That doesn't look like a Email").max(100).required("Email is required"),
    phoneNum: Yup.string()
        // .test('len', 'Must be exactly 10 digits', (val) => val.toString().length === 10)
        .min(8)
        .required('A phone number is required'),
    // country : Yup.string().max(20).required('Please Enter the Country Name'),
    // currency : Yup.string().max(10).required('Please Enter the Currency Name'),
    password: Yup.string().min(8).max(20).required('Password is required'),
    confirm_password: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match').min(8).max(20).required('Password is required'),
    description: Yup.string().max(500),
    isAgree: Yup.boolean().oneOf([true], "You must accept the terms and conditions")

});